// extracted by mini-css-extract-plugin
export default {"mainContainer":"Coupons_mainContainer__7Da9r","squareFilterBarWrapper":"Coupons_squareFilterBarWrapper__UrlMW"};